import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Store } from '@ngrx/store';
import { Actions } from '@ngrx/effects';
import {
  GET_SINGLE_PRICING_SUCCESS,
  GetSinglePricingAction,
  GetSinglePricingSuccessAction
} from './pricing-numbers.action';
import { IState } from '../../shared/models/state';
import { map } from 'rxjs/operators';
import { PricingItem } from './pricing-numbers';
import { Observable } from 'rxjs';

@Injectable()
export class SinglePricingResolve implements Resolve<PricingItem> {
  constructor(private store: Store<IState>, private action$: Actions) {}

  resolve(route: ActivatedRouteSnapshot): Observable<PricingItem> {
    this.store.dispatch(new GetSinglePricingAction({ pricingId: route.params.pricingId }));
    return this.action$
      .ofType(GET_SINGLE_PRICING_SUCCESS)
      .take(1)
      .pipe(map((action: GetSinglePricingSuccessAction) => action.payload));
  }
}
